// extracted by mini-css-extract-plugin
module.exports = {"overallTable":"style__overallTable__URKNf"};